import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { ApplicationStatusType } from 'src/app/enum/application-status-type';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ServiceChangeRequestService } from 'src/app/services/service-change-request.service';
import { TariffDataServicesService } from 'src/app/services/tariff-data-services.service';
import { UploaddataService } from 'src/app/services/uploaddata.service';
import { ProductDetailsPopupComponent } from '../product-details-popup/product-details-popup.component';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';
import { TransferaccountService } from 'src/app/services/transferaccount.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/app/enum/role-type';
import { ManageApplicationPopupComponent } from '../../Manage-Application/manage-application-popup/manage-application-popup.component';
import Swal from 'sweetalert2';
import { AdditionalQuestionsService } from 'src/app/services/additional-questions.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ProductService } from 'src/app/services/product.service';
import { UtilityService } from 'src/app/services/utility.service';
import { productchangeType } from 'src/app/enum/ProductchangeType';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PreferredPaymentType } from 'src/app/enum/preferred-payment-type';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-upgrade-approval',
  templateUrl: './upgrade-approval.component.html',
  styleUrls: ['./upgrade-approval.component.scss']
})
export class UpgradeApprovalComponent implements OnInit {
  value: any;
  form: FormGroup;
  trinationfeeform: FormGroup;
  titlelist: any;
  filteredList: any;
  languagelist: any;
  filteredList1: any;
  countrylist: any;
  filteredList2: any;
  isowner = false;
  data: any = [];
  data4: any = [];
  dataSource1: any = new MatTableDataSource(this.data);
  dataSource = new MatTableDataSource(this.data);
  datasource3 = new MatTableDataSource(this.data)
  isdoc = false
  isvoice = false;
  iscal = false;
  details: any;
  applicationstatus = ApplicationStatusType;
  editduration = false;
  isEmailAllowed: boolean = false;
  displayedColumns: string[] = [
    "Type",
    "Date",
    "FileName",
    "action"
  ];
  displayedColumns1: string[] = [
    "UpdatedOn",
    "Status",
    "DoneBy",
    "IPAddress",
    "RetentionAgentName"
  ];
  displayedColumns2: string[] = [
    "Address",
    "MDUUnitNumber",
    "MDUUnitName",
    "NetworkType",
    "PremiseReferenceISP",
    "ObjectID",
    "Action"
  ];
  displayedColumns3: string[] = [
    "IsONT",
    "ISP",
    "ONT",
    "FSAN",
    "CancellationDate",
    "RequiredServices",
    "BNumber",
    "Comments"
  ];

  displayedColumns4: string[] = [
    "ServiceProviderName",
    "ProductId",
    "ProductName",
    "Cost",

  ];
  data3: any = []
  dataSource3 = new MatTableDataSource(this.data3)
  dataSource4 = new MatTableDataSource(this.data3)

  selectedIndex: number;
  additionalQuestions: any;
  isbNumber = false;
  terinationfee: any;
  isResellerCustomer: any;
  applicationDetails: any;
  isRain: any;
  usdF3: any;
  application: any = {}
  address: any;
  customer: any;
  productName: any;
  transferAccount: any;
  sessionDataString: any;
  roleType = RoleType
  isView: any
  fulladdress: any;
  showLocationAddress = false
  vumatelRowCollection = []
  fileName: string;
  isFileSelected: boolean;
  FileExtention: string;
  filedate: string;
  file: File;
  Unupdatedapplication: any = {};
  serviceProviderId: any;
  existingProductId: any;
  newProductId: any;
  productList: any;
  groupedProducts: any;
  searchTerm: any;
  maxDate: string;
  minDate: string;
  ispNameList: any;
  showAdditionalQuestions = false
  isRequired = false
  ispAlreadySelectedName: any;
  showCurrentISPName = false
  ispSelectedName: any;
  labelShow = false
  isTenent = false
  isComplex = false
  ipAddress: any;
  showproduct
  salesrepList: any;
  PromocodeList: any;
  isPromotionChecked: boolean = false;
  isNotRecurringDate = true;
  retentionPromoDetails: any;
  serviceChangeRequestId: number;
  isRetentionPromoApplicable: boolean = false;
  allowedEmailsForRetention: any;
  applicationStatusLte: any;

  filteredList4: any[];
  filteredList5: any[] = [];
  filteredList6: any[];
  resellerOptions: any[] = [];
  allResellerSalesPersonData: any[] = [];
  selectedResellerId: number | null = null;
  allowedEmails: string[] = [];
  maxDuration: number;

  applicationId: any;
  data5: any = []
  dataSource5 = new MatTableDataSource(this.data5)
  displayedColumns5: string[] = [
    "UpdatedOn",
    "Status",
    "Notes",
    "DoneBy",
    "IPAddress"
  ];
  data6: any = []
  dataSource6 = new MatTableDataSource(this.data6)
  displayedColumns6: string[] = [
    "Notes",
    "Status",
    "CommentedOn",
    "Commentedby",
  ];

  data7: any = []
  dataSource7 = new MatTableDataSource(this.data7)

  displayedColumns7: string[] = [
    "ReferenceNumber",
    "Status",
    "OldProductId",
    "NewProductId",
    "UpdatedOn",
    "DoneBy",
  ];
  resellerSalesPersonList: any;
  isRetentionPromoSelected: boolean = false;
  matchedRetentionPromo: any;
  retentionPromoList: any;

  constructor(
    private activateroute: ActivatedRoute,
    private ApplicationDataService: ApplicationDataService,
    private formBuilder: FormBuilder,
    private lookupDataService: LookupDataServiceService,
    private UploaddataService: UploaddataService,
    private serviceChangeRequestService: ServiceChangeRequestService,
    private NavigationService: NavigationService,
    private tariffDataService: TariffDataServicesService,
    private matdialog: MatDialog,
    private uploaddataservice: UploaddataService,
    private transferaccountservice: TransferaccountService,
    private sessionService: UserSessionService,
    private additionalQuestionsService: AdditionalQuestionsService,
    private toastr: NotificationService,
    private ProductService: ProductService,
    private utilityService: UtilityService,
    private uploadDataService: UploaddataService,
    private toast: NotificationService,
  ) {

    this.activateroute.params.subscribe((params: any) => {
      debugger
      this.value = JSON.parse(params.id)
      console.log('routedata', this.value)
    });
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );
    console.log(this.sessionDataString);

  }

  ngOnInit(): void {
    this.isView = this.value?.isView
    this.FormInit()

    // this.form.controls['gender'].enable();
    console.log('akjsk', this.value)
    this.getdata();

    this.form.get('complex').valueChanges.subscribe(type => {
      if (type === '1') {
        this.isComplex = true;
        this.toggleBuildingTypeValidation('complex', true)
      } else if (type === '0') {
        this.isComplex = false
        this.toggleBuildingTypeValidation('complex', false)
      }
    });

    this.form.get('ownerShip').valueChanges.subscribe(type => {
      if (type === '2') {
        this.isTenent = true;
        this.toggleBuildingTypeValidation('ownerShip', true)
      } else if (type === '1') {
        this.isTenent = false
        this.toggleBuildingTypeValidation('ownerShip', false)
      }
    });

    this.form.get('resellerCode')?.valueChanges.subscribe(value => {
      if (value) {
        const selected = this.resellerOptions.find(item => item.resellerCode === value);
        this.selectedResellerId = selected?.resellerId ?? null;
        this.updateResellerSalesPersonList(value);
      } else {
        this.selectedResellerId = null;
        this.resellerSalesPersonList = []; // clear list if no reseller
        this.form.get('resellerSalesPerson').setValue(null);
        this.applyResellerSalesPersonRequired();
      }
    });

    this.getPromoSalesEmails();

    if (this.sessionDataString.roleId == 7) {
      Promise.all([
        this.loadApplicationHistory(),
        this.loadApplicationComments(),
        this.loadservichangeHistory(),
      ]);
    }
    this.CheckRetentionPromoIsApplicable(this.value.applicationId);
    this.getUserEmailsForAddingRetentionPromo();
    this.isTwentyThird();

  }

  FormInit() {
    this.form = this.formBuilder.group({
      gender: [null],
      customerReferenceNumber: [],
      reason: [],
      ownerShip: [],
      legalOwnerName: [],
      legalOwnerContactNumber: [],
      isVoice: [],
      voiceType: [],
      addressLine1: [],
      addressLine2: [],
      suburb: [],
      city: [],
      region: [],
      country: [],
      latitude: [],
      longitude: [],
      pinCode: [],
      title: [],
      firstName: [],
      lastName: [],
      dateOfBirth: [],
      homeLanguage: [],
      identificationNumber: [],
      primaryContactNumber: [],
      landLineNumber: [],
      mobileNumber: [],
      email: [],
      terminationFee: [null],
      aliasName: [],
      serviceProvider: [],
      totalProductCost: [],
      connectionActivatedOnTs: [],
      completeAddress: [],
      comments: [],
      requestedCancellationTs: [],
      reasontypeName: [],
      resellerName: [],
      routerCustomerComments: [],
      productId: [],
      customerNumber: [],
      resellerCode: [],
      salesRepCode: [],
      promoCode: [],
      isP_Id: [],
      currentISPName: [],
      currentISPNumber: [],
      cancellationDate: [],
      requiredServicesOn: [],
      complexName: ['', [Validators.required]],
      complex: [],
      complexUnitNo: ['', [Validators.required]],
      duration: [],
      returnAddress: [null],
      returnDate: [null],
      retentionPromoCode: [],
      resellerSalesPerson: [],
    })
    this.form.disable();
    this.trinationfeeform = this.formBuilder.group({
      fibreType: [],
      daysUsed: [],
      daysRemaining: [],
      vatAmount: [],
      feeWithoutVat: [],
      feeWithVat: [],

    })
    this.trinationfeeform.disable()

  }
  enableformvalue() {
    this.form.get('customerNumber').enable()
    this.form.get('title').enable()
    this.form.get('gender').enable()
    this.form.get('homeLanguage').enable()
    this.form.get('addressLine1').enable()
    this.form.get('addressLine2').enable()
    this.form.get('suburb').enable()
    this.form.get('city').enable()
    this.form.get('region').enable()
    this.form.get('country').enable()
    this.form.get('pinCode').enable()
    this.form.get('ownerShip').enable()
    this.form.get('legalOwnerName').enable()
    this.form.get('legalOwnerContactNumber').enable()
    this.form.get('productId').enable()
    this.form.get('resellerCode').enable()
    this.form.get('salesRepCode').enable()
    this.form.get('resellerSalesPerson').enable()
    this.form.get('isP_Id').enable()
    this.form.get('currentISPName').enable()
    this.form.get('currentISPNumber').enable()
    this.form.get('cancellationDate').enable()
    this.form.get('requiredServicesOn').enable()
    this.form.get('complexName').enable()
    this.form.get('complex').enable()
    this.form.get('complexUnitNo').enable()
    this.form.get('currentISPNumber').enable()
    this.form.get('promoCode').enable()
    this.form.get('duration').enable()
    this.form.get('retentionPromoCode').enable()
  }

  updateResellerSalesPersonList(resellerCode: string): void {
    if (!resellerCode) {
      this.resellerSalesPersonList = [];
      this.form.get('resellerSalesPerson').setValue(null);
      return;
    }

    const filtered = (this.allResellerSalesPersonData || [])
      .filter((item: any) => item?.resellerCode === resellerCode)
      .reduce((acc: any[], item: any) => {
        const code = item?.resellerSalesCode?.toUpperCase();
        if (code && !acc.some(existing => existing.resellerSalesCode === code)) {
          acc.push({ ...item, resellerSalesCode: code });
        }
        return acc;
      }, []);

    this.resellerSalesPersonList = filtered;
    if (!filtered.length) {
      this.form.get('resellerSalesPerson').setValue(null);
    } else if (filtered.length === 1) {
      this.form.get('resellerSalesPerson').setValue(filtered[0].resellerSalesCode);
    } else {
      const current = this.form.get('resellerSalesPerson').value;
      if (!filtered.some(item => item.resellerSalesCode === current)) {
        this.form.get('resellerSalesPerson').setValue(null);
      }
    }
    debugger
    this.applyResellerSalesPersonRequired();
  }

  applyResellerSalesPersonRequired(): void {
    const control = this.form.get('resellerSalesPerson');
    if (!control) {
      return;
    }
    if (this.form.value.resellerCode && this.resellerSalesPersonList?.length > 0) {
      control.setValidators([Validators.required]);
    } else {
      control.removeValidators(Validators.required);
    }
    control.updateValueAndValidity();
  }

  getPromoSalesEmails(): void {
    this.lookupDataService.gettingEmailForPromoSales().subscribe({
      next: (emails: any) => {
        this.allowedEmails = emails.promoSalesEmails;
      },
      error: (err) => {
      }
    });
  }

  isSalesRepDisabled(): boolean {
    const userEmail = this.sessionDataString?.emailid?.toLowerCase() ?? '';
    const resellerCode = this.form.value.resellerCode;

    return (!this.allowedEmails.map(e => e.toLowerCase()).includes(userEmail)) || !!resellerCode;
  }

  isPromoDisabled(): boolean {
    const userEmail = this.sessionDataString?.emailid?.toLowerCase() ?? '';

    return (!this.allowedEmails.map(e => e.toLowerCase()).includes(userEmail));
  }


  // getResellerSalesPerson(resellerCode: string): void {
  //   this.lookupDataService.getResellerSalesPerson(resellerCode).subscribe({
  //     next: (result: any) => {
  //       this.resellerSalesPersonList = result && result.length > 0 ? result : [];
  //       if (!this.resellerSalesPersonList.length) {
  //         this.form.get('resellerSalesPerson').setValue(null);
  //       } else if (this.resellerSalesPersonList.length === 1) {
  //         const salesCode = this.resellerSalesPersonList[0]?.resellerSalesCode?.toUpperCase();
  //         if (salesCode) {
  //           this.form.get('resellerSalesPerson').setValue(salesCode);
  //         }
  //       }
  //       console.log('Reseller Sales Person List:', this.resellerSalesPersonList);
  //     },
  //     error: () => {
  //       this.resellerSalesPersonList = [];
  //       this.form.get('resellerSalesPerson').setValue(null);
  //     }
  //   });
  // }


  async getdata() {
    if (this.value.title == 'service')
      this.ApplicationDataService.getServiceChangeApplicationViewByid(this.value.applicationId).subscribe((result) => {
        this.form.patchValue(result);
        this.details = result;
        this.form.patchValue({
          ...result,
          gender: result.gender.toString(),
          ownerShip: result.ownerShip.toString(),
        });
        if (result.ownerShip == 2)
          this.isowner = true;
        if (result.voiceType) {
          this.form.controls['voiceType'].setValue(this.form.value.voiceType?.toString());
          this.isvoice = true;
        }
        console.log("------------------", this.form.value);
      })
    if (this.value.title == 'cancel') {
      this.ApplicationDataService.getServiceCancellationApplicationViewByid(this.value.applicationId).subscribe((result) => {
        this.form.patchValue(result);
        this.details = result;
        this.form.patchValue({
          ...result,
          gender: result.gender.toString(),
          ownerShip: result.ownerShip.toString(),
        });
        if (result.ownerShip == 2)
          this.isowner = true;
        if (result.voiceType) {
          this.form.controls['voiceType'].setValue(this.form.value.voiceType?.toString());
          this.isvoice = true;
        }
        let twoAddressLine = this.form.value.addressLine1 + "\n" + this.form.value.addressLine2;
        let completeAddress = twoAddressLine + " \n" + "REGION: " + this.form.value.region + "\n" + "CITY: " + this.form.value.city;
        this.form.controls['completeAddress'].setValue(completeAddress);
        console.log("------------------", this.form.value);
        console.log(this.form.value.terminationFee)
        if (this.form.value.terminationFee) {
          this.tariffDataService.GetTerminationCalculationFromCancellation(this.value.serviceChangeRequestId).subscribe((result) => {
            const fullString = `${result.feeWithoutVat} + ${result.vatAmount} => R ${result.feeWithVat}`;
            this.iscal = true;
            this.trinationfeeform.patchValue({
              ...result,
              feeWithVat: fullString,
            })
            this.terinationfee = result;
            console.log('fee', this.trinationfeeform)
          })
        }
      })
    }
    if (this.value.title == 'transfer' || this.value.title == 'cancel' || this.value.title == 'fiber' || this.value.title == 'wirelessrain' || this.value.title == 'view' || this.value.title == 'viewfiber') {

      this.ApplicationDataService.getApplicationAdditionalQuestions(this.value.applicationId).subscribe((res: any) => {
        this.additionalQuestions = res;
        if (this.additionalQuestions) {
          this.additionalQuestions = this.additionalQuestions;
          if (this.additionalQuestions.bNumber !== undefined && this.additionalQuestions.bNumber !== '') {
            this.isbNumber = true;
          }
          this.data3 = [{ isONT: this.additionalQuestions.isONT, isISP: this.additionalQuestions.isISP, makeOfONT: this.additionalQuestions.makeOfONT, fsanDeviceSerialNo: this.additionalQuestions.fsanDeviceSerialNo, cancellationDate: this.additionalQuestions.cancellationDate, requiredServicesOn: this.additionalQuestions.requiredServicesOn, bNumber: this.additionalQuestions.bNumber, comments: this.additionalQuestions.comments, }]
          this.dataSource3 = new MatTableDataSource(this.data3)
        }
      })
    }

    if (this.value.title == 'transfer' || this.value.title == 'fiber' || this.value.title == 'wirelessrain' || this.value.title == 'view' || this.value.title == 'viewfiber') {
      this.executetransferdata()
    }
    if (this.value.title == 'editapplication' || this.value.title == 'fibereditapplication') {
      this.enableformvalue();
      this.executewirelessapllication()
      this.getminyears()
      this.loadAdditionalQuestionDetails()
      this.getUserIp()
    }
    this.lookupDataService.gettitle(true).subscribe((result) => {
      this.languagelist = result;
      this.filteredList = [...this.languagelist];
    })
    this.lookupDataService.getlanguage(true).subscribe((result) => {
      this.titlelist = result;
      this.filteredList1 = [...this.titlelist];
    })
    this.lookupDataService.getCountryType(true).subscribe((result) => {
      this.countrylist = result;
      this.filteredList2 = [...this.countrylist];
    })
    this.lookupDataService.getManageSalesRepList().subscribe((result) => {
      this.salesrepList = result;
      this.filteredList4 = [...this.salesrepList];
    })

    this.lookupDataService.getAllResellerSalesPerson().subscribe((result: any[]) => {
      this.allResellerSalesPersonData = result || [];
      const uniqueResellers = new Map<string, any>();
      (this.allResellerSalesPersonData || []).forEach((item: any) => {
        if (item?.resellerCode && !uniqueResellers.has(item.resellerCode)) {
          uniqueResellers.set(item.resellerCode, {
            resellerId: item.resellerId,
            resellerCode: item.resellerCode,
          });
        }
      });
      this.resellerOptions = Array.from(uniqueResellers.values());
      this.filteredList5 = [...this.resellerOptions];
      if (this.form.value.resellerCode) {
        this.updateResellerSalesPersonList(this.form.value.resellerCode);
      }
    });

    if (this.value.title != 'transfer' && this.value.title != 'fiber' && this.value.title != 'editapplication' && this.value.title != 'fibereditapplication' && this.value.title != 'wirelessrain' && this.value.title != 'view' && this.value.title != 'viewfiber') {
      this.UploaddataService.getServiceChangeRequestDocuments(this.value.serviceChangeRequestId).subscribe((result) => {
        console.log(result)
        if (result.length > 0) {
          this.isdoc = true;
          this.data = result.map((item: any) => ({
            ...item,
            uploadedDate: this.formatDate(item.uploadedDate)
          }));
          this.dataSource = new MatTableDataSource(this.data);
        }
      })
      this.serviceChangeRequestService.getServiceCancellationHistory(this.value.applicationId).subscribe((result) => {
        console.log(result)
        this.data = result.map((item: any) => ({
          ...item,
          updatedOnTs: this.formatDate(item.updatedOnTs)
        }));
        this.dataSource1 = new MatTableDataSource(this.data);
      })
    }
  }
  async executetransferdata() {
    let servicequeue = [
      firstValueFrom(this.ApplicationDataService.checkResellerCustomerWithApplicationId(this.value.applicationId)),
      firstValueFrom(this.ApplicationDataService.getApplicationDetails(this.value.applicationId, false, false)),
      firstValueFrom(this.UploaddataService.getAllApplicationDocuments(this.value.applicationId)),
    ]
    let response = await Promise.all(servicequeue)
    this.isResellerCustomer = response[0]
    this.applicationDetails = response[1]
    if (response[2].length > 0) {
      this.isdoc = true;
      this.data = response[2].map((item: any) => ({
        ...item,
        uploadedDate: this.formatDate(item.uploadedDate)
      }));
      this.dataSource = new MatTableDataSource(this.data);
    }
    if (this.applicationDetails != null) {
      this.isRain = this.applicationDetails.isRain;
      this.usdF3 = this.applicationDetails.usdF3;
      this.form.get('routerCustomerComments').setValue(this.applicationDetails.routerCustomerComments)
      this.application = {};

      this.application = this.applicationDetails

      var postData: any = {};
      postData.resellerCode = this.applicationDetails.customerAddressMapping.customer.user.resellerCode
      this.ApplicationDataService.getResellerName(postData).subscribe((result) => {
        this.form.get('resellerName').setValue(result?.resellerName)
      })
      this.address = this.applicationDetails.customerAddressMapping.address
      this.customer = this.applicationDetails.customerAddressMapping.customer
      // this.customer.dateOfBirth = moment(this.customer.dateOfBirth).format('MM/DD/YYYY');
      this.form.patchValue({
        ...this.customer,
        gender: this.customer.gender.toString(),
        ownerShip: this.applicationDetails.ownerShip.toString(),
      });

      if (this.applicationDetails.salesRepCode) {
        this.form.get('resellerSalesPerson').setValue(this.applicationDetails.salesRepCode.toUpperCase());
      }
      if (this.applicationDetails.resellerSalesCode) {
        this.form.get('resellerSalesPerson').setValue(this.applicationDetails.resellerSalesCode.toUpperCase());
      }
      if (this.applicationDetails.resellerCode) {
        this.updateResellerSalesPersonList(this.applicationDetails.resellerCode);
      }
      this.form.patchValue(this.address)
      this.productName = this.applicationDetails.productName;
      if (this.application.existingApplicationId != null && this.application.existingApplicationId != "") {
        this.transferaccountservice.getTransferAccountforApproval(this.application.existingApplicationId).subscribe((result) => {
          if (result)
            var transferAccountDetails = result;

          this.transferAccount = transferAccountDetails
        });
      }

      console.log(this.form.value);

      if (this.applicationDetails.isComplex == true) {
        this.application.complex = 1;
        this.application.complexName = this.applicationDetails.complexName;
        this.application.complexUnitNo = this.applicationDetails.complexUnitNo;
      } else {
        this.application.complex = 0;
        this.application.complexName = this.applicationDetails.complexName;
        this.application.complexUnitNo = this.applicationDetails.complexUnitNo;
      }
    }
    else {
      //access denied redirection
    }
  }
  toggleBuildingTypeValidation(type, isValidationReq) {
    let controls = type === 'complex' ? ['complexName', 'complexUnitNo'] : ['legalOwnerName', 'legalOwnerContactNumber']
    controls.forEach(ctrl => {
      if (isValidationReq) {
        this.form.get(ctrl).setValidators(Validators.required);
        this.form.get(ctrl).updateValueAndValidity();
      } else {
        this.form.get(ctrl).removeValidators(Validators.required);
        this.form.get(ctrl).markAsUntouched();
        this.form.get(ctrl).updateValueAndValidity();
      }
    })
  }
  async executewirelessapllication() {
    let response = await firstValueFrom(this.ApplicationDataService.getApplicationDetails(this.value.applicationId, false, false))
    this.applicationDetails = response
    if (this.applicationDetails != null) {
      var postData: any = {};
      postData.resellerCode = this.applicationDetails.resellerCode
      this.ApplicationDataService.getResellerName(postData).subscribe((result) => {
        if (result)
          this.form.get('resellerName').setValue(result?.resellerName)

      });
      this.application = {};
      this.application = this.applicationDetails

      this.Unupdatedapplication = {};
      this.Unupdatedapplication = { ...this.applicationDetails }

      this.isRain = this.applicationDetails.isRain;
      this.address = this.applicationDetails.customerAddressMapping.address
      this.customer = this.applicationDetails.customerAddressMapping.customer

      // let customerName = this.customer.firstName + " " + this.customer.lastName;
      // this.form.get('customerName').setValue(response?.resellerName)
      if (this.application.salesRepCode != null) {
        this.form.get('salesRepCode').setValue(this.applicationDetails.salesRepCode.toUpperCase());
      }
      if (this.application.resellerCode != null) {
        this.application.resellerCode = this.application.resellerCode.toUpperCase();
      }
      this.form.patchValue(this.applicationDetails)
      if (this.applicationDetails.resellerCode) {
        this.form.get('resellerCode').setValue(this.applicationDetails.resellerCode.toUpperCase());
      }

      if (this.applicationDetails.resellerCode) {
        this.updateResellerSalesPersonList(this.applicationDetails.resellerCode);
      }
      if (this.applicationDetails.resellerSalesCode) {
        this.form.get('resellerSalesPerson').setValue(this.applicationDetails.resellerSalesCode.toUpperCase());
      }

      this.form.patchValue({
        ...this.customer,
        gender: this.customer.gender.toString(),
        ownerShip: this.applicationDetails.ownerShip.toString(),
      });
      this.form.patchValue(this.address)
      debugger
      if (this.applicationDetails.promoCode)
        this.form.get('productId').disable()
      this.productName = this.applicationDetails.productName;
      this.serviceProviderId = this.applicationDetails.serviceProviderId;
      this.existingProductId = this.applicationDetails.productId;
      // this.form.get('productId').setValue(this.applicationDetails?.newProductId)
      // this.existingProductId = this.existingProductId;
      this.newProductId = this.applicationDetails.newProductId
      var postData: any = {};
      postData.serviceProviderId = this.serviceProviderId;
      postData.existingProductId = this.existingProductId;
      postData.productClassification = this.applicationDetails.productClassification;
      postData.ProductChangePage = productchangeType.Editapplication
      this.ProductService.getAllProductByServiceProviderIdAndProductId(postData).subscribe((result) => {
        this.productList = result
        if (this.newProductId)
          this.productName = this.productList.find(x => x.id == this.newProductId).aliasName

        this.productList.forEach(item => {
          item.productCategoryName = item.productSubCategory.subCategoryName;
          this.groupedProducts = this.productList.reduce((acc, product) => {
            let category = product.productCategoryName;
            let group = acc.find(g => g.categoryName === category);

            if (!group) {
              group = { categoryName: category, products: [] };
              acc.push(group);
            }

            group.products.push(product);
            return acc;
          }, []);
        });
      })
      this.labelShow = this.applicationDetails.isProductChange

      if (this.applicationDetails.isComplex == true) {
        this.application.complex = '1';
        this.application.complexName = this.applicationDetails.complexName;
        this.application.complexUnitNo = this.applicationDetails.complexUnitNo;
      } else {
        this.application.complex = '0';
        this.application.complexName = this.applicationDetails.complexName;
        this.application.complexUnitNo = this.applicationDetails.complexUnitNo;
      }
      this.lookupDataService.GetApplicablePromoList(this.application.serviceProviderId, this.application.productId).subscribe((result) => {
        this.PromocodeList = result;
        this.filteredList6 = [...this.PromocodeList];
      })
      this.form.get('complex').setValue(this.application.complex)
      this.form.get('complexName').setValue(this.application.complexName)
      this.form.get('complexUnitNo').setValue(this.application.complexUnitNo)
      console.log(this.form.value);

    }
    else {
      //access denied redirection
    }
  }

  onProductSelected(event, product, item) {
    if (event.isUserInput)
      this.selectedproductvalidate(product, item);
  }

  selectedproductvalidate(product, item) {
    const productSubCategoryId = this.productList.find(p => p.id == this.applicationDetails.productId).productSubCategoryId
    if (product.productSubCategoryId == productSubCategoryId) {
      setTimeout(() => {
        this.form.get('productId')?.setValue(this.applicationDetails.productId);
      });
      this.toastr.showError('Please select Different Subcategory Product')
      // need to check if  popup for sim only code needed from v1
    }

  }

  filteredGroupedProducts() {
    if (!this.searchTerm) {
      return this.groupedProducts;
    }

    return this.groupedProducts.map(group => ({
      categoryName: group.categoryName,
      products: group.products.filter(product =>
        product.aliasName.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    })).filter(group => group.products.length > 0);
  }
  getminyears() {
    var nowInMs = new Date().getTime();
    var majorAge = 1000 * 60 * 60 * 24 * 365 * 18;
    var minAge = 1000 * 60 * 60 * 24 * 365 * 150;
    var diffyearMax = new Date(nowInMs - majorAge);
    var diffyearMin = new Date(nowInMs - minAge);

    this.maxDate = moment(diffyearMax).format("YYYY/MM/DD");
    this.minDate = moment(diffyearMin).format("YYYY/MM/DD");

  }
  loadAdditionalQuestionDetails() {
    this.lookupDataService.getISPList().subscribe((result) => {
      if (result) {
        this.ispNameList = result;
      }
    });
    if (this.value.applicationId != 0) {
      this.additionalQuestionsService.getAdditionalQuestions(this.value.applicationId).subscribe((result) => {
        if (result.isONT) {
          this.showAdditionalQuestions = true;
          this.additionalQuestions = {};
          this.additionalQuestions = result;

          if (result.cancellationDate != null && result.cancellationDate != undefined)
            this.additionalQuestions.cancellationDate = moment(result.cancellationDate).format("YYYY/MM/DD");
          if (result.requiredServicesOn != null && result.requiredServicesOn != undefined)
            this.additionalQuestions.requiredServicesOn = moment(result.requiredServicesOn).format("YYYY/MM/DD");
          if (result.isP_Id != undefined && result.isP_Id != null) {
            this.isRequired = true;
            this.ispAlreadySelectedName = this.ispNameList.find(x => x.key === result.isP_Id);
            if (this.ispAlreadySelectedName.value == "Others") {
              this.showCurrentISPName = true;
            }
          }

          if (this.additionalQuestions.isONT == true)
            this.additionalQuestions.isONT = 1
          else
            this.additionalQuestions.isONT = 2
          if (this.additionalQuestions.isISP == true)
            this.additionalQuestions.isISP = 1
          else
            this.additionalQuestions.isISP = 2
        }
      });
    }
  }
  ispNameOnChange() {
    let item = this.form.value.isP_Id
    if (item != null) {
      this.isRequired = true;

      this.ispSelectedName = this.ispNameList.find(x => x.key === item)
      if (this.ispSelectedName.value == "Others") {
        this.showCurrentISPName = true;
      }
      else {
        this.showCurrentISPName = false;
      }
    }
    else {
      this.isRequired = false;
    }
  }
  // selectProduct() {
  //   if (this.form.value.productId == this.newProductId) {
  //     this.form.get('productId').setValue(this.applicationDetails.productId)
  //     this.toastr.showError('Please select Different Subcategory Product')
  //   }

  //   //need to code popup for sim only


  // }
  getUserIp() {
    this.utilityService.getIpAddress().subscribe((ip) => {

      this.ipAddress = ip;
    });
  }

  onPromoChange() {
    if (this.Unupdatedapplication.promoCode != this.form.value.promoCode) {
      const duration = this.PromocodeList.find(p => p.value === this.form.value.promoCode)?.key
      this.form.get('duration').setValue(duration);
      this.editduration = true
      this.maxDuration = duration
    }
    else
      this.editduration = false

  }
  onDurationInput(event: any): void {
    const input = event.target;
    let value = parseInt(input.value, 10);

    if (isNaN(value)) {
      input.value = '';
      this.form.get('duration')?.setValue('');
      return;
    }

    if (value < 1) {
      input.value = '1';
      this.form.get('duration')?.setValue(1);
    } else if (value > this.maxDuration) {
      input.value = this.maxDuration.toString();
      this.form.get('duration')?.setValue(this.maxDuration);
    }
  }

  updateeditApplication() {
    if (this.additionalQuestions != undefined) {
      if (this.form.value.isP_Id != undefined && this.form.value.isP_Id != null) {
        if (this.form.value.cancellationDate == undefined || this.form.value.cancellationDate == null) {
          this.toastr.showError("Please Fill Cancellation date with current ISP");
          return;
        }
        if (this.form.value.requiredServicesOn == undefined || this.form.value.requiredServicesOn == null) {
          this.toastr.showError("Please Fill Required Home-Connect Activation Date");
          return;
        }
        this.ispSelectedName = this.ispNameList.find(x => x.key === this.form.value.isP_Id)

        if (this.ispSelectedName[0].value == "Others") {
          if (this.form.value.currentISPName == undefined || this.form.value.currentISPName == null) {
            this.toastr.showError("Please Fill Current ISP Name");
            return;
          }
        }
      }
    }
    var postData: any = {};
    var formValues = this.form.getRawValue()
    Object.keys(this.form.value).forEach(key => {
      if (key in this.application) {
        this.application[key] = this.form.value[key];
      }
      if (key in this.application.customerAddressMapping.address)
        this.application.customerAddressMapping.address[key] = this.form.value[key];
      if (key in this.application.customerAddressMapping.customer)
        this.application.customerAddressMapping.customer[key] = this.form.value[key];
    });


    postData = this.application
    // postData = {...formValues,...this.application}

    if (this.form.value.resellerCode != undefined && this.form.value.salesRepCode != undefined) {
      if (this.form.value.resellerCode.length > 0 && this.form.value.salesRepCode.length > 0) {
        Swal.fire('Warning!!', 'Please enter either salesrep code or reseller code', 'warning')
        return;
      }
    }
    if (!postData.customerAddressMapping) {
      postData.customerAddressMapping = {};
    }
    postData.existingProductId = this.existingProductId;
    postData.newExistingProductId = this.form.getRawValue().productId
    if (postData.customerAddressMapping.customer.user != null) {
      postData.customerAddressMapping.customer.user.refrenceNumber = this.application.customerNumber;

      if (this.form.value.complex == 1) {
        postData.IsComplex = true;
        postData.ComplexName = this.form.value.complexName;
        postData.ComplexUnitNo = this.form.value.complexUnitNo;
      }
      else {
        postData.IsComplex = false;
        postData.ComplexName = null;
        postData.ComplexUnitNo = null;
      }
      if (this.Unupdatedapplication.promoCode != this.form.value.promoCode) {
        postData.promoCodeModified = true
      }
      postData.newProductOnceOffFeeId = postData.productOnceOffFeeId;
      postData.IsHasRetentionPromo = this.isRetentionPromoApplicable;
      postData.RetentionPromoCode = this.retentionPromoDetails?.retentionPromoCode;
      postData.resellerSalesCode = this.form.value.resellerSalesPerson ? this.form.value.resellerSalesPerson : null;
      console.log("Postcall data:", postData);

      if (this.form.invalid) {
        this.toastr.showError("Please fill all the required fields")
        return;
      }

      this.ApplicationDataService.editsaveApplication(postData).subscribe((Result) => {

        if ((this.Unupdatedapplication.resellerCode != this.form.value.resellerCode) || (this.Unupdatedapplication.salesRepCode != this.form.value.salesRepCode) || (this.Unupdatedapplication.promoCode != this.form.value.promoCode)) {

          var savePostData: any = {};
          savePostData.applicationId = postData.id;
          if ((this.Unupdatedapplication.resellerCode != this.form.value.resellerCode) || (this.Unupdatedapplication.salesRepCode != this.form.value.salesRepCode)) {
            savePostData.resellerOlddata = this.Unupdatedapplication.resellerCode;
            savePostData.resellerNewData = this.application.resellerCode;
            savePostData.salesOlddata = this.Unupdatedapplication.salesRepCode;
            savePostData.salesNewData = this.application.salesRepCode;
          }
          else {
            savePostData.resellerOlddata = null
            savePostData.resellerNewData = null
            savePostData.salesOlddata = null
            savePostData.salesNewData = null
          }

          savePostData.oldPromoCode = this.Unupdatedapplication.promoCode;
          savePostData.promoCode = this.application.promoCode;
          savePostData.ipAddress = this.ipAddress;
          this.ApplicationDataService.saveSalesResellerAuditTrail(savePostData).subscribe((result) => {
            if (result) {

              if (this.additionalQuestions != undefined) {
                var postDataAQ: any = {};
                postDataAQ = this.additionalQuestions;
                postDataAQ.applicationId = this.value.applicationId;

                if (postDataAQ.currentISPName != null && postDataAQ.currentISPName != undefined) {
                  this.ispSelectedName = this.ispNameList.find(x => x.key === this.form.value.isP_Id)
                  if (this.ispSelectedName.value != "Others") {
                    postDataAQ.currentISPName = null;
                  }
                }
                postDataAQ.isONT = 1

                this.ApplicationDataService.saveAdditionalQuestions(postDataAQ).subscribe((result) => {
                  this.toastr.showSuccess('Data updated Successfully');
                  if (this.isRain)
                    this.NavigationService.goToManageRainApplication();
                  else
                    this.NavigationService.gotomanagefiber();
                });
              }
              else {
                this.toastr.showSuccess('Data updated Successfully');
                if (this.isRain)
                  this.NavigationService.goToManageRainApplication();
                else
                  this.NavigationService.gotomanagefiber();
              }
            }
          })
        }
        else if (postData.IsHasRetentionPromo) {
          if (Result.result != null) {
            this.toastr.showSuccess('Data updated Successfully');
            this.NavigationService.gotomanagefiber();
          }
        }
        else {
          if (this.additionalQuestions != undefined) {
            var postDataAQ: any = {};
            postDataAQ = this.additionalQuestions;
            postDataAQ.applicationId = this.value.applicationId;

            if (postDataAQ.currentISPName != null && postDataAQ.currentISPName != undefined) {
              this.ispSelectedName = this.ispNameList.find(x => x.key === this.form.value.isP_Id)


              if (this.ispSelectedName.value != "Others") {
                postDataAQ.currentISPName = null;
              }
            }
            postDataAQ.isONT = 1

            this.ApplicationDataService.saveAdditionalQuestions(postDataAQ).subscribe((result) => {
              this.toastr.showSuccess('Data updated Successfully');
              if (this.isRain)
                this.NavigationService.goToManageRainApplication();
              else
                this.NavigationService.gotomanagefiber();
            })
          }
          else {
            this.toastr.showSuccess('Data updated Successfully');
            if (this.isRain)
              this.NavigationService.goToManageRainApplication();
            else
              this.NavigationService.gotomanagefiber();
          }

        }
      })
    }
  }

  //transfer
  async save(status: any, serviceProviderId?: any, id?) {
    if (status == this.applicationstatus.Approved && (serviceProviderId == '36' || serviceProviderId == '24')) {
      this.ApplicationDataService.CheckCreditVet(this.value.applicationId).subscribe((result) => {
        const txt = `
          <div class="mx-5" style="margin: 0 auto; font-size: 20px; text-align: left;">
            <div style="display: flex; justify-content: space-between; margin-bottom: 10px; width: 100%;">
              <span>onBoarding Level:</span>
              <span style="font-weight: bold;">${result?.result?.onBoarding}</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 10px; width: 100%;">
              <span>onBoarding Credit Score:</span>
              <span style="font-weight: bold;">${result?.result?.onBoardingValue}</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 10px; width: 100%;">
              <span>Affordability Level:</span>
              <span style="font-weight: bold;">${result?.result?.affordability}</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 10px; width: 100%;">
              <span>Affordability Range:</span>
              <span style="font-weight: bold;">${result?.result?.affordabilityValue}</span>
            </div>
          </div>`;
        const Yes = 'Yes';
        const No = 'No';
        Swal.fire({
          html: txt,
          title: 'Confirmation',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#7D32DE',
          cancelButtonColor: '#23C00A',
          confirmButtonText: Yes,
          cancelButtonText: No,
        }).then(async (result) => {
          if (result.value) {
            this.validatesave(status)
          }
          else {
            return
          }
        });
      })
    }
    else
      this.validatesave(status, serviceProviderId)
  }

  async validatesave(status, serviceProviderId?) {
    // Mark all form fields as touched to display validation errors
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.markAsTouched();
    });

    // Check if form is invalid and has required errors
    if (this.form.invalid) {
      this.toastr.showError('Please fill all required fields');
      return;
    }

    if (status == this.applicationstatus.Rejected || status == this.applicationstatus.VumatelOrderRejected) {
      const dialogref = this.matdialog.open(ManageApplicationPopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "40%",
        data: {
          title: 'Reason for Reject',
          head: 'rejectcommand',
          data: { serviceProviderId: serviceProviderId },
        }
      });
      const result = await firstValueFrom(dialogref.afterClosed());
      if (result) {

        this.application.applicationStatus = status;
        if (result.comment) {
          this.application.reason = result.comment;
          this.application.rejectedByCVScore = result.creditvetreason;
        }
        else
          this.application.reason = result;
        console.log(this.application);

        this.updateApplication(status);
      }
    }
    else if (status == this.applicationstatus.Cancelled) {
      const dialogref = this.matdialog.open(ManageApplicationPopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "30%",
        data: {
          title: 'Reason for Cancel',
          head: 'rejectcommand',
        }
      });
      const result = await firstValueFrom(dialogref.afterClosed());
      if (result) {
        this.application.applicationStatus = status;
        this.application.reason = result;
        this.updateApplication(status);
      }
    }
    else if (status == this.applicationstatus.VumatelOrderPending) {
      this.NavigationService.dashboard();
    }
    else if (status != null && status != undefined && status != "" && status != 0) {

      if (this.application.usdF3) {
        if (this.transferAccount != null) {
          var requestedDate = moment(this.transferAccount.accountTransferEffectiveDate, 'YYYY/MM/DD').format('YYYY/MM/DD');
          const dialogref = this.matdialog.open(ManageApplicationPopupComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            width: "30%",
            data: {
              title: 'Application Approval',
              head: 'transferapprove',
              requestedDate: requestedDate
            }
          });
          const result = await firstValueFrom(dialogref.afterClosed());
          if (result) {
            this.application.adminApprovedDate = moment(result, 'YYYY/MM/DD').format('YYYY/MM/DD');
            this.application.applicationStatus = status;
            this.updateApplication(status);
          }
        }
      }
      else {
        this.application.applicationStatus = status;
        this.updateApplication(status);
      }
    }
  }

  paymentStatusUpdateLte() {

    this.applicationId = this.application?.id,
      this.applicationStatusLte = ApplicationStatusType.PaymentPending;
    this.ApplicationDataService.paymentStatusUpdateLte(this.applicationId, this.applicationStatusLte).subscribe((
      result: any) => {
      if (result == true) {
        this.application.applicationStatus = ApplicationStatusType.PaymentPending;
        this.toastr.showSuccess("Approved Successfully!!");
        this.goback()
      } else {
        this.toastr.showError("Oops something went wrong")

      }
    });
  }

  updateApplication(applicationStatus) {
    this.application.applicationStatus = applicationStatus;

    if (this.application.preferredInstallationDate) {
      this.application.preferredInstallationDate = moment(this.application.preferredInstallationDate).format('YYYY/MM/DD')
    }
    var postData: any = {};

    postData = this.application
    if (!postData.customerAddressMapping) {
      postData.customerAddressMapping = {};
    }
    postData.customerAddressMapping.address = this.address;
    postData.customerAddressMapping.customer = this.customer;
    this.ApplicationDataService.saveApplication(postData).subscribe((result) => {
      if (result != null) {
        if (result.message != undefined || result.count != undefined) {
          if (result.message == "successful") {
            this.showLocationAddress = true;
            this.fulladdress = result.fulladdress;
            this.vumatelRowCollection = result.response;
            this.datasource3 = new MatTableDataSource(this.vumatelRowCollection)
          }
          else if (result.count == 0) {
            var temptext = result.message;
            if (temptext) {
              Swal.fire('Oops!!', temptext, 'error')
            }
            else {
              Swal.fire('Oops!!', 'No response from Vumatel!', 'error')
            }
          }
        }
        else {
          if (applicationStatus == this.applicationstatus.Approved) {
            this.additionalQuestionsService.notificationMailToISP(this.value.applicationId).subscribe((result) => {
              // if (this.applicationDetails.serviceProviderId == 43 && this.applicationDetails.preferredPaymentType == PreferredPaymentType.DebitImmediately) {
              //   this.paymentStatusUpdateLte();
              // }

              this.toastr.showSuccess("Approved Successfully!!");
              this.goback()

            })
          }
          else if (applicationStatus == this.applicationstatus.Rejected || applicationStatus == this.applicationstatus.VumatelOrderRejected) {
            this.additionalQuestionsService.notificationMailToISP(this.value.applicationId).subscribe((result) => {
              this.toastr.showSuccess("Rejected Successfully!!");
              this.goback()
            })
          }
        }
      }
    })
  }
  // onTabChange(event: MatTabChangeEvent) {
  //   this.selectedIndex = event.index
  // }

  download(id) {
    if (this.value.title != 'transfer' && this.value.title != 'fiber' && this.value.title != 'editapplication' && this.value.title != 'fibereditapplication' && this.value.title != 'wirelessrain')
      this.uploaddataservice.downloadFile(id).subscribe((data) => {
        if (data != null) {
          const link = document.createElement("a");
          link.href = data.baseUrl + data.byteImage;
          link.download = `${data.filename}`; //.${data.fileExtention}`;
          link.click();
        }
      })
    else
      this.UploaddataService.downloadFile(id).subscribe((data) => {
        if (data != null) {
          const link = document.createElement("a");
          link.href = data.baseUrl + data.byteImage;
          link.download = `${data.filename}`; //.${data.fileExtention}`;
          link.click();
        }
      });
  }
  upload(item: any) {
    let documentType
    if (item.documentTypeString == 'Proof of ID/Passport') {
      documentType = 1
    } else if (item.documentTypeString == 'Proof of Residence') {
      documentType = 2
    } else if (item.documentTypeString == 'Debit Form') {
      documentType = 3
    }

    item.action = false
    const dialogref = this.matdialog.open(ManageApplicationPopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "50%",
      data: {
        title: 'Documents Required',
        head: 'transferdoc',
        applicationId: this.value.applicationId,
        data: [item],
        documentType: documentType
      }
    });
    dialogref.afterClosed().subscribe(async (result) => {
      if (result) {
        let response = await firstValueFrom(this.UploaddataService.getAllApplicationDocuments(this.value.applicationId))
        if (response.length > 0) {
          this.isdoc = true;
          this.data = response.map((item: any) => ({
            ...item,
            uploadedDate: this.formatDate(item.uploadedDate)
          }));
          this.dataSource = new MatTableDataSource(this.data);
        }
      }
    })

  }

  // uploadEft() {
  //   let documentType
  //   documentType = 17
  //   const dialogref = this.matdialog.open(ManageApplicationPopupComponent, {
  //     autoFocus: false,
  //     disableClose: true,
  //     panelClass: 'mat-dialog',
  //     width: "50%",
  //     data: {
  //       title: 'Application Approval',
  //       head: 'eftDocs',
  //       applicationId: this.value.applicationId,
  //       data: [],
  //       documentType: documentType
  //     }
  //   });
  //   dialogref.afterClosed().subscribe(async (result) => {
  //     if (result == '')
  //       return;
  //     else if (result == true)
  //       this.save(this.applicationstatus.Approved, this.application.serviceProviderId, this.application.Id)
  //     else
  //       this.toast.showError("Oops Something went wrong")

  //   })
  // }

  goback() {
    if (this.value.title == 'service')
      this.NavigationService.goToManageservicechange();
    else if (this.sessionDataString.roleId == 7)
      this.NavigationService.resellerapplication()
    else if (this.value.title == 'cancel')
      this.NavigationService.gotomanageCancellation();
    else if (this.value.title == 'transfer')
      this.NavigationService.gotoaccounttransfer()
    else if (this.value.title == 'fiber' || this.value.title == 'fibereditapplication' || this.value.title == 'viewfiber')
      this.NavigationService.gotomanagefiber()
    else if (this.value.title == 'editapplication' || this.value.title == 'wirelessrain' || this.value.title == 'view')
      this.NavigationService.goToManageRainApplication()

  }

  formatDate(date: Date): string {
    const dates = new Date(date);

    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return dates.toLocaleString('en-US', options).replace(',', '');
  };


  viewproduct() {
    let title
    if (this.value.title != 'transfer')
      title = 'acknowledgment'
    else
      title = 'transfer'
    if (this.data4.length == 0) {
      this.tariffDataService.GetProductDetailsByApplicationId(this.value.applicationId).subscribe((result) => {
        debugger
        this.data4 = [result];
        if (title != 'transfer') {
          const row = {
            serviceProvider: '',
            productId: result.onceOffProductId,
            aliasName: result.onceOffProductAliceName,
            totalProductCost: result.onceOffFeeExcludingVAT
          }
          this.data4.push(row)
        }
        console.log(this.data4)
        this.dataSource4 = new MatTableDataSource(this.data4);
        this.showproduct = !this.showproduct
        const scrollElement = document.querySelector('.scroll');
        if (scrollElement)
          scrollElement.scrollTo({ top: 0, behavior: 'smooth' });
      })
    }
    else {
      const scrollElement = document.querySelector('.scroll');
      if (scrollElement)
        scrollElement.scrollTo({ top: 0, behavior: 'smooth' });
      this.showproduct = !this.showproduct

    }

  }

  loadApplicationHistory() {
    return new Promise((resolve, reject) => {
      this.ApplicationDataService.getApplicationHistory(this.value.applicationId).subscribe(
        (result) => {
          this.data5 = result;
          this.dataSource5 = new MatTableDataSource(this.data5);
          resolve(result);
        },
        (error) => reject(error)
      );
    });
  }

  loadApplicationComments() {
    return new Promise((resolve, reject) => {
      this.ApplicationDataService.getApplicationComments(this.value.applicationId).subscribe(
        (result) => {
          this.data6 = result;
          this.dataSource6 = new MatTableDataSource(this.data6);
          resolve(result);
        },
        (error) => reject(error)
      );
    });
  }

  loadservichangeHistory() {
    return new Promise((resolve, reject) => {
      this.ApplicationDataService.getApplicationServiceChangeHistory(this.value.applicationId).subscribe(
        (result) => {
          this.data7 = result
          this.dataSource7 = new MatTableDataSource(this.data7)
          resolve(result);
        },
        (error) => reject(error)
      );

    });
  }

  redirectPage(premise_ref_isp, objectID, address) {
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      html: 'Are you sure you would like to place an order for this address, ' + address + ' ?',
      title: 'Confirmation',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then(async (result) => {
      if (result.value) {
        this.showLocationAddress = false;
        let applicationStatus = this.applicationstatus.Approved;
        this.application.premise_ref_isp = premise_ref_isp;
        this.application.objectID = objectID;
        this.updateApplication(applicationStatus);
      }

    });
  }
  convertToUpperCase(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }

  onRetentionPromoCodeSelected(event?: MatSelectChange) {
    if (event != null) {
      this.isRetentionPromoSelected = event.value;
      if (this.isRetentionPromoSelected) {

        this.matchedRetentionPromo = this.retentionPromoDetails.find(
          item => item.retentionPromoCode === event.value
        ) ?? null;
      }
    }
  }

  promotionChange(event?: MatCheckboxChange) {
    if (event != null) {
      this.isPromotionChecked = event.checked;
      this.getRetentionPromotionPricing(this.value.applicationId);
    }
  }

  getRetentionPromotionPricing(applicationId) {
    this.serviceChangeRequestService.getRetentionPromotionPricing(applicationId).subscribe(
      (res: any) => {
        if (res) {
          this.retentionPromoDetails = res
          this.form.patchValue({
            retentionPromoCode: res.map(item => item.retentionPromoCode),
          });
          this.retentionPromoList = res.map(item => item.retentionPromoCode);
        }
      })

  }

  CheckRetentionPromoIsApplicable(applicationId) {
    this.serviceChangeRequestService.CheckRetentionPromoIsApplicable(applicationId).subscribe(
      (res: any) => {
        if (res)
          this.isRetentionPromoApplicable = res
        // else
        //   this.toastr.showInfo("Retention promotion can't apply to this record")
      }
    )
  }

  getUserEmailsForAddingRetentionPromo() {
    if (this.sessionDataString.roleId != 17) {
      this.serviceChangeRequestService.getUserEmailsForAddingRetentionPromo().subscribe(
        (res: any) => {
          if (res) {
            this.allowedEmails = res
            this.isEmailAllowed = this.isEmailAllowedMethod();
            // this.allowedEmailsForRetention = res.map(e => e.toLowerCase());
            // const userEmail = this.sessionDataString?.emailid?.toLowerCase() ?? '';
            // this.isEmailAllowed = this.allowedEmailsForRetention.includes(userEmail);
          }
        })
    }
    else
      this.isEmailAllowed = true;
  }

  isEmailAllowedMethod(): boolean {
    const userEmail = this.sessionDataString?.emailid?.toLowerCase() ?? '';
    console.log(userEmail)
    return (this.allowedEmails.map(e => e.toLowerCase()).includes(userEmail));
  }

  isTwentyThird() {
    const today = new Date();
    console.log("today date", today.getDate())
    if (today.getDate() === 23) {
      this.isNotRecurringDate = false;
    }
    else {
      this.isNotRecurringDate = true;
    }
  }

  moveToNewApplication(appId) {
    Swal.fire({
      html: `
    <p style="font-size:18px; margin:0;">
      Are you sure you want to move this application to 
      New Application?
    </p>
  `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      reverseButtons: true,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.ApplicationDataService.moveToNewApp(appId).subscribe((result: any) => {
          if (result) {
            this.toast.showSuccess(result);
            this.goback();

          }
        });
      }
    });
  }


}
